import React, { useRef } from 'react'

const Message = ({ 
    heading = '', 
    description = '', 
    placeholder = '',
    setMessage,  
    value = '',
}) => {
    const inputRef = useRef(null)
    return (
        <div>
            <div className="space-y-1">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                    { heading }
                </h3>
                <p className="max-w-2xl text-sm text-gray-500">{ description }</p>
            </div>
            <textarea
                rows="10"
                value = {value}
                ref={inputRef}
                className="px-4 py-2 rounded-sm text-sm border border-gray-200 w-full focus:border-blue-500"
                placeholder={ placeholder }
                onFocus={() => inputRef.current.classList.add('h-40')}
                onBlur={() => {
                    if (inputRef.current && !inputRef.current.value.length) {
                        inputRef.current.classList.remove('h-40')
                    }
                }}
                onChange={({ target: { value } }) => setMessage(value)}
            />
        </div>
    );
}

export default Message;